import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Card, Col, Form, Row, Modal } from "react-bootstrap";

import {
  updateWorkPackageData,
  fetchWorkPackages,
} from "../../../../store/features/workPackage/workPackageSlice";

// Validation schema
const validationSchema = Yup.object().shape({
  approvalStatus: Yup.boolean().required("accepted is required"),
  rejectionReason: Yup.string().when("approvalStatus", (rejectionReason, schema) => {
    return rejectionReason === false
      ? schema.required("not AcceptedReason is required")
      : schema.notRequired();
  }),
});

const AcceptedWpFormModal = ({ wpInfoData, showAccepted, setShowAccepted }) => {
  const dispatch = useDispatch();

  const initialValues = {
    approvalStatus: true,
    rejectionReason: "",
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      if (wpInfoData._id) {

         values._id = wpInfoData._id;
        values.approvalStatus = values.approvalStatus ? "Accepted" : "Not Accepted";
        values.rejectionReason = values.rejectionReason;

        const formData = new FormData();
          for (let key in values) {
            if (key === "attachments" && Array.isArray(values.attachments)) {
              values.attachments.forEach((file) => {
                formData.append("attachments", file);
              });
            } else {
              formData.append(key, values[key]);
            }
          }
        await dispatch(updateWorkPackageData(formData)).unwrap();
        toast.success("WorkPackage status updated successfully");
      }
      await dispatch(fetchWorkPackages());
      setShowAccepted(false);
      resetForm();
    } catch (err) {
      toast.error("Error WorkPackage status updated");
    }
  };

  return (
    <Modal show={showAccepted} onHide={() => setShowAccepted(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{wpInfoData.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Body>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({
                values,
                handleChange,
                handleSubmit,
                touched,
                errors,
                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Check
                          name="approvalStatus"
                          type="switch"
                          label="Accepted/Not Accepted"
                          checked={values.approvalStatus}
                          onChange={(e) =>
                            setFieldValue("approvalStatus", e.target.checked)
                          }
                        />
                      </Form.Group>
                    </Col>
                    {!values.approvalStatus && (
                      <Col md={12}>
                        <Form.Control
                          type="text"
                          as="textarea"
                          name="rejectionReason"
                          value={values.rejectionReason}
                          onChange={handleChange}
                          isInvalid={
                            touched.rejectionReason &&
                            !!errors.rejectionReason
                          }
                          rows={3}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rejectionReason}
                        </Form.Control.Feedback>
                      </Col>
                    )}
                  </Row>

                  <Row className="mt-3">
                    <Col className="text-end">
                      <Button
                        variant="secondary"
                        onClick={() => {
                          resetForm();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="ms-2"
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default AcceptedWpFormModal;
